import React from "react"
import "./beehiiv-subscribe-embed.css"

const BEEHIIV_FORM_ID = "6bd181f4-cb82-4396-b352-56af2a36d068"
const BEEHIIV_LOADER_URL = "https://subscribe-forms.beehiiv.com/v3/loader.js"

const BeehiivSubscribeEmbed = ({ className }) => {
  const containerRef = React.useRef(null)
  const pawTimeoutRef = React.useRef(null)
  const [isPawActive, setIsPawActive] = React.useState(false)
  const shellClassName = ["beehiiv-subscribe-shell", className]
    .concat(isPawActive ? ["is-paw-active"] : [])
    .filter(Boolean)
    .join(" ")

  const triggerPaw = React.useCallback(() => {
    if (pawTimeoutRef.current) {
      window.clearTimeout(pawTimeoutRef.current)
    }

    setIsPawActive(false)

    window.requestAnimationFrame(() => {
      setIsPawActive(true)
    })

    pawTimeoutRef.current = window.setTimeout(() => {
      setIsPawActive(false)
    }, 2600)
  }, [])

  React.useEffect(() => {
    const container = containerRef.current
    if (!container) return undefined

    container.innerHTML = ""

    const script = document.createElement("script")
    script.async = true
    script.src = BEEHIIV_LOADER_URL
    script.dataset.beehiivForm = BEEHIIV_FORM_ID
    container.appendChild(script)

    return () => {
      container.innerHTML = ""
    }
  }, [])

  React.useEffect(() => {
    return () => {
      if (pawTimeoutRef.current) {
        window.clearTimeout(pawTimeoutRef.current)
      }
    }
  }, [])

  return (
    <div
      className={shellClassName}
      onMouseEnter={triggerPaw}
      role="presentation"
    >
      <span className="beehiiv-paw-mark" aria-hidden="true" />
      <div className="beehiiv-subscribe-form" ref={containerRef} />
    </div>
  )
}

export default BeehiivSubscribeEmbed
